// extracted by mini-css-extract-plugin
module.exports = {"attentionIcon":"NftAttentionModal_attentionIcon__RlMwR"};